// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calculators_div__ktkng {
    border-radius: 20.188px;
    box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);
    background-color: var(--Primary, #e7ecef);
    display: flex;
    flex-direction: column;
  }
  .Calculators_div-2__RR8-s {
    align-self: stretch;
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .Calculators_div-2__RR8-s {
      max-width: 100%;
    }
  }
  .Calculators_div-3__Yp\\+C- {
    border-radius: 0px 0px 16.842px 16.842px;
    box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #f8f8fb);
    align-self: stretch;
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding: 10px 78px -15px 14px;
  }
  @media (max-width: 991px) {
    .Calculators_div-3__Yp\\+C- {
      max-width: 100%;
      flex-wrap: wrap;
      padding-right: 20px;
    }
  }
  .Calculators_div-4__enjiX {
    align-self: stretch;
    display: flex;
    width: 498px;
    max-width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
  }
  @media (max-width: 991px) {
    .Calculators_div-4__enjiX {
      flex-wrap: wrap;
    }
  }
  .Calculators_img__qM2Cg {
    aspect-ratio: 2.18;
    object-fit: contain;
    object-position: center;
    width: 168px;
    overflow: hidden;
    align-self: start;
    max-width: 100%;
  }
  .Calculators_div-5__K6\\+Ou {
    align-items: flex-start;
    align-self: start;
    display: flex;
    margin-top: 8px;
    width: 303px;
    max-width: 100%;
    flex-grow: 1;
    flex-basis: auto;
    justify-content: space-between;
    gap: 20px;
  }
  .Calculators_div-6__s6WBv {
    color: var(--half-secondary, #516f91);
    align-self: stretch;
    font: 600 15px Lato, sans-serif;
  }
  .Calculators_div-7__1SZf0 {
    color: var(--half-secondary, #516f91);
    align-self: stretch;
    white-space: nowrap;
    font: 600 15px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-7__1SZf0 {
      white-space: initial;
    }
  }
  .Calculators_div-8__zquMA {
    align-self: center;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin: auto 0;
  }
  .Calculators_div-9__p8MrN {
    color: var(--Secondary, #274c77);
    align-self: center;
    margin: auto 0;
    font: 500 15px Lato, sans-serif;
  }
  .Calculators_div-10__NQ8OT {
    justify-content: flex-end;
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    gap: 13px;
  }
  @media (max-width: 991px) {
    .Calculators_div-10__NQ8OT {
      justify-content: center;
    }
  }
  .Calculators_img-2__qOi7H {
    aspect-ratio: 2;
    object-fit: contain;
    object-position: center;
    width: 10px;
    stroke-width: 1.684px;
    stroke: var(--Secondary, #274c77);
    overflow: hidden;
    align-self: center;
    max-width: 100%;
    margin: auto 0;
  }
  .Calculators_div-11__XFxka {
    color: var(--Secondary, #274c77);
    text-align: center;
    align-self: center;
    margin: auto 0;
    font: 700 15px Lato, sans-serif;
  }
  .Calculators_img-3__GXDte {
    aspect-ratio: 1.03;
    object-fit: contain;
    object-position: center;
    width: 30px;
    overflow: hidden;
    border-radius: 50%;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_img-4__rmvaW {
    aspect-ratio: 1.03;
    object-fit: contain;
    object-position: center;
    width: 30px;
    overflow: hidden;
    align-self: center;
    max-width: 100%;
    margin: auto 0;
  }
  .Calculators_div-12__a5CBT {
    align-self: stretch;
    width: 100%;
    margin: 29px 0 36px;
    padding: 0 20px;
  }
  @media (max-width: 991px) {
    .Calculators_div-12__a5CBT {
      max-width: 100%;
    }
  }
  .Calculators_div-13__2IN2F {
    gap: 20px;
    display: flex;
  }
  @media (max-width: 991px) {
    .Calculators_div-13__2IN2F {
      flex-direction: column;
      align-items: stretch;
      gap: 0px;
    }
  }
  .Calculators_column__Os1Fj {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 17%;
    margin-left: 0px;
  }
  @media (max-width: 991px) {
    .Calculators_column__Os1Fj {
      width: 100%;
    }
  }
  .Calculators_div-14__\\+xkSU {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .Calculators_div-14__\\+xkSU {
      margin-top: 40px;
    }
  }
  .Calculators_div-15__3Aawe {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Secondary, #274c77);
    align-self: stretch;
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 14px 86px 14px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-15__3Aawe {
      padding: 0 20px;
    }
  }
  .Calculators_img-5__Hn0su {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-16__eviq0 {
    color: var(--Primary, #e7ecef);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-16__eviq0 {
      white-space: initial;
    }
  }
  .Calculators_div-17__LDzFs {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 13px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 13px 50px 13px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-17__LDzFs {
      padding: 0 20px;
    }
  }
  .Calculators_img-6__rVKg8 {
    aspect-ratio: 0.96;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-18__FJvvJ {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-18__FJvvJ {
      white-space: initial;
    }
  }
  .Calculators_div-19__5v95D {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 13px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 14px 67px 14px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-19__5v95D {
      padding: 0 20px;
    }
  }
  .Calculators_img-7__PsMy0 {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-20__CmDBU {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-20__CmDBU {
      white-space: initial;
    }
  }
  .Calculators_div-21__WlePO {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 13px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 14px 91px 14px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-21__WlePO {
      padding: 0 20px;
    }
  }
  .Calculators_img-8__bQsUt {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-22__YQXGu {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-22__YQXGu {
      white-space: initial;
    }
  }
  .Calculators_div-23__Ar2JW {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 13px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 14px 75px 14px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-23__Ar2JW {
      padding: 0 20px;
    }
  }
  .Calculators_img-9__T-xAw {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-24__bTpxD {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-24__bTpxD {
      white-space: initial;
    }
  }
  .Calculators_div-25__fkaLJ {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 12px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 14px 26px 14px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-25__fkaLJ {
      padding: 0 20px;
    }
  }
  .Calculators_img-10__OIJ05 {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-26__sQ-45 {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-26__sQ-45 {
      white-space: initial;
    }
  }
  .Calculators_div-27__57icD {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 13px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 14px 68px 14px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-27__57icD {
      padding: 0 20px;
    }
  }
  .Calculators_img-11__DVj4D {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 25px;
    transform: rotate(-90deg);
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-28__pW2Yw {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-28__pW2Yw {
      white-space: initial;
    }
  }
  .Calculators_div-29__4BVZK {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 13px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 13px 58px 13px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-29__4BVZK {
      padding: 0 20px;
    }
  }
  .Calculators_img-12__VDU7F {
    aspect-ratio: 0.96;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-30__YxT-w {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-30__YxT-w {
      white-space: initial;
    }
  }
  .Calculators_div-31__xyTUt {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 13px;
    width: 100%;
    justify-content: space-between;
    gap: 14px;
    padding: 9px 118px 9px 49px;
  }
  @media (max-width: 991px) {
    .Calculators_div-31__xyTUt {
      padding: 0 20px;
    }
  }
  .Calculators_div-32__WSy5d {
    align-self: start;
    display: flex;
    flex-direction: column;
  }
  .Calculators_div-33__ID-B6 {
    border-radius: 50%;
    align-self: center;
    display: flex;
    width: 12px;
    height: 12px;
    flex-direction: column;
  }
  .Calculators_img-13__1nONM {
    aspect-ratio: 1.55;
    object-fit: contain;
    object-position: center;
    width: 100%;
    fill: #fff;
    overflow: hidden;
    align-self: stretch;
    flex-grow: 1;
  }
  .Calculators_div-34__fdxrY {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-34__fdxrY {
      white-space: initial;
    }
  }
  .Calculators_div-35__lPp7S {
    align-items: flex-start;
    border-radius: 0px 16.842px 16.842px 0px;
    background-color: var(--Primary, #e7ecef);
    align-self: stretch;
    display: flex;
    margin-top: 84px;
    width: 100%;
    justify-content: space-between;
    gap: 18px;
    padding: 14px 107px 14px 54px;
  }
  @media (max-width: 991px) {
    .Calculators_div-35__lPp7S {
      margin-top: 40px;
      padding: 0 20px;
    }
  }
  .Calculators_img-14__TGmku {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 25px;
    overflow: hidden;
    align-self: stretch;
    max-width: 100%;
  }
  .Calculators_div-36__0Xt7c {
    color: var(--Secondary, #274c77);
    align-self: center;
    white-space: nowrap;
    margin: auto 0;
    font: 600 17px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-36__0Xt7c {
      white-space: initial;
    }
  }
  .Calculators_column-2__BOKyN {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 28%;
    margin-left: 20px;
  }
  @media (max-width: 991px) {
    .Calculators_column-2__BOKyN {
      width: 100%;
    }
  }
  .Calculators_div-37__FOClc {
    display: flex;
    margin-top: 10px;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .Calculators_div-37__FOClc {
      max-width: 100%;
      margin-top: 40px;
    }
  }
  .Calculators_div-38__FvG4I {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    align-self: start;
    margin-left: 61px;
    white-space: nowrap;
    font: 500 20px/110% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-38__FvG4I {
      margin-left: 10px;
      white-space: initial;
    }
  }
  .Calculators_div-39__JoKCS {
    disply: flex;
    flex-direction: column;
    fill: #198ddc;
    overflow: hidden;
    align-self: start;
    position: relative;
    display: flex;
    min-height: 72px;
    margin-top: 82px;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding: 22px 0 22px 151px;
  }
  @media (max-width: 991px) {
    .Calculators_div-39__JoKCS {
      max-width: 100%;
      flex-wrap: wrap;
      padding-left: 20px;
      margin-top: 40px;
    }
  }
  .Calculators_img-15__sscmE {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .Calculators_div-40__zJIK6 {
    position: relative;
    color: #fff;
    text-align: center;
    margin-top: 6px;
    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  .Calculators_img-16__S-5J7 {
    aspect-ratio: 1.14;
    object-fit: contain;
    object-position: center;
    width: 33px;
    fill: #fff;
    overflow: hidden;
    align-self: start;
    max-width: 100%;
  }
  .Calculators_div-41__hvw7f {
    disply: flex;
    flex-direction: column;
    fill: #198ddc;
    overflow: hidden;
    align-self: start;
    position: relative;
    display: flex;
    min-height: 72px;
    margin-top: 58px;
    width: 100%;
    padding: 29px 80px;
  }
  @media (max-width: 991px) {
    .Calculators_div-41__hvw7f {
      max-width: 100%;
      margin-top: 40px;
      padding: 0 20px;
    }
  }
  .Calculators_img-17__ORDfH {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .Calculators_div-42__NAqcV {
    position: relative;
    color: #fff;
    text-align: center;
    align-self: center;
    white-space: nowrap;
    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-42__NAqcV {
      white-space: initial;
    }
  }
  .Calculators_div-43__RTsMO {
    disply: flex;
    flex-direction: column;
    color: #fff;
    text-align: center;
    align-self: start;
    position: relative;
    white-space: nowrap;
    fill: #198ddc;
    overflow: hidden;
    min-height: 72px;
    margin-top: 67px;
    width: 100%;
    padding: 30px 57px 24px 91px;
    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-43__RTsMO {
      white-space: initial;
      max-width: 100%;
      margin-top: 40px;
      padding: 0 20px 0 30px;
    }
  }
  .Calculators_img-18__ZPne8 {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .Calculators_div-44__hHM-c {
    position: relative;
  }
  .Calculators_div-45__xpslx {
    disply: flex;
    flex-direction: column;
    color: #fff;
    text-align: center;
    align-self: start;
    position: relative;
    white-space: nowrap;
    fill: #198ddc;
    overflow: hidden;
    min-height: 72px;
    margin-top: 77px;
    width: 100%;
    flex-grow: 1;
    padding: 30px 72px 30px 99px;
    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Calculators_div-45__xpslx {
      white-space: initial;
      max-width: 100%;
      margin-top: 40px;
      padding: 0 20px 0 30px;
    }
  }
  .Calculators_img-19__NTwYf {
    position: absolute;
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .Calculators_div-46__NxiUV {
    position: relative;
  }
  .Calculators_column-3__N3F\\+5 {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 54%;
    margin-left: 20px;
  }
  @media (max-width: 991px) {
    .Calculators_column-3__N3F\\+5 {
      width: 100%;
    }
  }
  .Calculators_img-20__Lkfde {
    aspect-ratio: 1.17;
    object-fit: contain;
    object-position: center;
    width: 100%;
    overflow: hidden;
    margin-top: 87px;
    flex-grow: 1;
  }
  @media (max-width: 991px) {
    .Calculators_img-20__Lkfde {
      max-width: 100%;
      margin-top: 40px;
    }
  }

  .Calculators_myLoanerContainer__TI6xE {
    display: flex;
    flex-direction: column;
    width: 20px;
    border-radius: 16.842px;
    box-shadow:
      0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
      background-color: var(--boxes, #F8F8FB);
    align-self: center;
    display: flex;
    width: 350px;
    height: 550px;
    max-width: 100%;
    text-align: center;
    margin-right: 10px;
    margin-top: -40px;
  }
  
  .Calculators_myLoanerContent__86w30 {
    display: flex;
    margin-top: 10px;
    flex-direction: column;
    align-self: center;
    width: 230px;
    font-size: 24px;
    justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/components/Calculators.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,wEAAwE;IACxE,yCAAyC;IACzC,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,wCAAwC;IACxC,wEAAwE;IACxE,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,6BAA6B;EAC/B;EACA;IACE;MACE,eAAe;MACf,eAAe;MACf,mBAAmB;IACrB;EACF;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;EAChB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;EACA;IACE;MACE,uBAAuB;IACzB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,SAAS;IACT,aAAa;EACf;EACA;IACE;MACE,sBAAsB;MACtB,oBAAoB;MACpB,QAAQ;IACV;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,SAAS;IACT,6BAA6B;EAC/B;EACA;IACE;MACE,gBAAgB;MAChB,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;EACjC;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE,WAAW;IACX,6CAA6C;IAC7C,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB;gBACY;EACd;EACA;IACE;MACE,iBAAiB;MACjB,oBAAoB;IACtB;EACF;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,0BAA0B;EAC5B;EACA;IACE;MACE,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,gBAAgB;IAClB;EACF;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf;gBACY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,eAAe;IACjB;EACF;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB;gBACY;EACd;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B;gBACY;EACd;EACA;IACE;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,sBAAsB;IACxB;EACF;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B;gBACY;EACd;EACA;IACE;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,sBAAsB;IACxB;EACF;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB;kEAC8D;MAC5D,uCAAuC;IACzC,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB","sourcesContent":[".div {\n    border-radius: 20.188px;\n    box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);\n    background-color: var(--Primary, #e7ecef);\n    display: flex;\n    flex-direction: column;\n  }\n  .div-2 {\n    align-self: stretch;\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div-2 {\n      max-width: 100%;\n    }\n  }\n  .div-3 {\n    border-radius: 0px 0px 16.842px 16.842px;\n    box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #f8f8fb);\n    align-self: stretch;\n    display: flex;\n    width: 100%;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 10px 78px -15px 14px;\n  }\n  @media (max-width: 991px) {\n    .div-3 {\n      max-width: 100%;\n      flex-wrap: wrap;\n      padding-right: 20px;\n    }\n  }\n  .div-4 {\n    align-self: stretch;\n    display: flex;\n    width: 498px;\n    max-width: 100%;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20px;\n  }\n  @media (max-width: 991px) {\n    .div-4 {\n      flex-wrap: wrap;\n    }\n  }\n  .img {\n    aspect-ratio: 2.18;\n    object-fit: contain;\n    object-position: center;\n    width: 168px;\n    overflow: hidden;\n    align-self: start;\n    max-width: 100%;\n  }\n  .div-5 {\n    align-items: flex-start;\n    align-self: start;\n    display: flex;\n    margin-top: 8px;\n    width: 303px;\n    max-width: 100%;\n    flex-grow: 1;\n    flex-basis: auto;\n    justify-content: space-between;\n    gap: 20px;\n  }\n  .div-6 {\n    color: var(--half-secondary, #516f91);\n    align-self: stretch;\n    font: 600 15px Lato, sans-serif;\n  }\n  .div-7 {\n    color: var(--half-secondary, #516f91);\n    align-self: stretch;\n    white-space: nowrap;\n    font: 600 15px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-7 {\n      white-space: initial;\n    }\n  }\n  .div-8 {\n    align-self: center;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin: auto 0;\n  }\n  .div-9 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    margin: auto 0;\n    font: 500 15px Lato, sans-serif;\n  }\n  .div-10 {\n    justify-content: flex-end;\n    align-items: flex-start;\n    align-self: stretch;\n    display: flex;\n    gap: 13px;\n  }\n  @media (max-width: 991px) {\n    .div-10 {\n      justify-content: center;\n    }\n  }\n  .img-2 {\n    aspect-ratio: 2;\n    object-fit: contain;\n    object-position: center;\n    width: 10px;\n    stroke-width: 1.684px;\n    stroke: var(--Secondary, #274c77);\n    overflow: hidden;\n    align-self: center;\n    max-width: 100%;\n    margin: auto 0;\n  }\n  .div-11 {\n    color: var(--Secondary, #274c77);\n    text-align: center;\n    align-self: center;\n    margin: auto 0;\n    font: 700 15px Lato, sans-serif;\n  }\n  .img-3 {\n    aspect-ratio: 1.03;\n    object-fit: contain;\n    object-position: center;\n    width: 30px;\n    overflow: hidden;\n    border-radius: 50%;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .img-4 {\n    aspect-ratio: 1.03;\n    object-fit: contain;\n    object-position: center;\n    width: 30px;\n    overflow: hidden;\n    align-self: center;\n    max-width: 100%;\n    margin: auto 0;\n  }\n  .div-12 {\n    align-self: stretch;\n    width: 100%;\n    margin: 29px 0 36px;\n    padding: 0 20px;\n  }\n  @media (max-width: 991px) {\n    .div-12 {\n      max-width: 100%;\n    }\n  }\n  .div-13 {\n    gap: 20px;\n    display: flex;\n  }\n  @media (max-width: 991px) {\n    .div-13 {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 0px;\n    }\n  }\n  .column {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 17%;\n    margin-left: 0px;\n  }\n  @media (max-width: 991px) {\n    .column {\n      width: 100%;\n    }\n  }\n  .div-14 {\n    display: flex;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div-14 {\n      margin-top: 40px;\n    }\n  }\n  .div-15 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Secondary, #274c77);\n    align-self: stretch;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 14px 86px 14px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-15 {\n      padding: 0 20px;\n    }\n  }\n  .img-5 {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-16 {\n    color: var(--Primary, #e7ecef);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-16 {\n      white-space: initial;\n    }\n  }\n  .div-17 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 13px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 13px 50px 13px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-17 {\n      padding: 0 20px;\n    }\n  }\n  .img-6 {\n    aspect-ratio: 0.96;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-18 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-18 {\n      white-space: initial;\n    }\n  }\n  .div-19 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 13px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 14px 67px 14px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-19 {\n      padding: 0 20px;\n    }\n  }\n  .img-7 {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-20 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-20 {\n      white-space: initial;\n    }\n  }\n  .div-21 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 13px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 14px 91px 14px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-21 {\n      padding: 0 20px;\n    }\n  }\n  .img-8 {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-22 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-22 {\n      white-space: initial;\n    }\n  }\n  .div-23 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 13px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 14px 75px 14px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-23 {\n      padding: 0 20px;\n    }\n  }\n  .img-9 {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-24 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-24 {\n      white-space: initial;\n    }\n  }\n  .div-25 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 12px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 14px 26px 14px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-25 {\n      padding: 0 20px;\n    }\n  }\n  .img-10 {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-26 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-26 {\n      white-space: initial;\n    }\n  }\n  .div-27 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 13px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 14px 68px 14px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-27 {\n      padding: 0 20px;\n    }\n  }\n  .img-11 {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    transform: rotate(-90deg);\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-28 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-28 {\n      white-space: initial;\n    }\n  }\n  .div-29 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 13px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 13px 58px 13px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-29 {\n      padding: 0 20px;\n    }\n  }\n  .img-12 {\n    aspect-ratio: 0.96;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-30 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-30 {\n      white-space: initial;\n    }\n  }\n  .div-31 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 13px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 14px;\n    padding: 9px 118px 9px 49px;\n  }\n  @media (max-width: 991px) {\n    .div-31 {\n      padding: 0 20px;\n    }\n  }\n  .div-32 {\n    align-self: start;\n    display: flex;\n    flex-direction: column;\n  }\n  .div-33 {\n    border-radius: 50%;\n    align-self: center;\n    display: flex;\n    width: 12px;\n    height: 12px;\n    flex-direction: column;\n  }\n  .img-13 {\n    aspect-ratio: 1.55;\n    object-fit: contain;\n    object-position: center;\n    width: 100%;\n    fill: #fff;\n    overflow: hidden;\n    align-self: stretch;\n    flex-grow: 1;\n  }\n  .div-34 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-34 {\n      white-space: initial;\n    }\n  }\n  .div-35 {\n    align-items: flex-start;\n    border-radius: 0px 16.842px 16.842px 0px;\n    background-color: var(--Primary, #e7ecef);\n    align-self: stretch;\n    display: flex;\n    margin-top: 84px;\n    width: 100%;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 14px 107px 14px 54px;\n  }\n  @media (max-width: 991px) {\n    .div-35 {\n      margin-top: 40px;\n      padding: 0 20px;\n    }\n  }\n  .img-14 {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 25px;\n    overflow: hidden;\n    align-self: stretch;\n    max-width: 100%;\n  }\n  .div-36 {\n    color: var(--Secondary, #274c77);\n    align-self: center;\n    white-space: nowrap;\n    margin: auto 0;\n    font: 600 17px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-36 {\n      white-space: initial;\n    }\n  }\n  .column-2 {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 28%;\n    margin-left: 20px;\n  }\n  @media (max-width: 991px) {\n    .column-2 {\n      width: 100%;\n    }\n  }\n  .div-37 {\n    display: flex;\n    margin-top: 10px;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div-37 {\n      max-width: 100%;\n      margin-top: 40px;\n    }\n  }\n  .div-38 {\n    color: #000;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    align-self: start;\n    margin-left: 61px;\n    white-space: nowrap;\n    font: 500 20px/110% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-38 {\n      margin-left: 10px;\n      white-space: initial;\n    }\n  }\n  .div-39 {\n    disply: flex;\n    flex-direction: column;\n    fill: #198ddc;\n    overflow: hidden;\n    align-self: start;\n    position: relative;\n    display: flex;\n    min-height: 72px;\n    margin-top: 82px;\n    width: 100%;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 22px 0 22px 151px;\n  }\n  @media (max-width: 991px) {\n    .div-39 {\n      max-width: 100%;\n      flex-wrap: wrap;\n      padding-left: 20px;\n      margin-top: 40px;\n    }\n  }\n  .img-15 {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n  .div-40 {\n    position: relative;\n    color: #fff;\n    text-align: center;\n    margin-top: 6px;\n    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  .img-16 {\n    aspect-ratio: 1.14;\n    object-fit: contain;\n    object-position: center;\n    width: 33px;\n    fill: #fff;\n    overflow: hidden;\n    align-self: start;\n    max-width: 100%;\n  }\n  .div-41 {\n    disply: flex;\n    flex-direction: column;\n    fill: #198ddc;\n    overflow: hidden;\n    align-self: start;\n    position: relative;\n    display: flex;\n    min-height: 72px;\n    margin-top: 58px;\n    width: 100%;\n    padding: 29px 80px;\n  }\n  @media (max-width: 991px) {\n    .div-41 {\n      max-width: 100%;\n      margin-top: 40px;\n      padding: 0 20px;\n    }\n  }\n  .img-17 {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n  .div-42 {\n    position: relative;\n    color: #fff;\n    text-align: center;\n    align-self: center;\n    white-space: nowrap;\n    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-42 {\n      white-space: initial;\n    }\n  }\n  .div-43 {\n    disply: flex;\n    flex-direction: column;\n    color: #fff;\n    text-align: center;\n    align-self: start;\n    position: relative;\n    white-space: nowrap;\n    fill: #198ddc;\n    overflow: hidden;\n    min-height: 72px;\n    margin-top: 67px;\n    width: 100%;\n    padding: 30px 57px 24px 91px;\n    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-43 {\n      white-space: initial;\n      max-width: 100%;\n      margin-top: 40px;\n      padding: 0 20px 0 30px;\n    }\n  }\n  .img-18 {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n  .div-44 {\n    position: relative;\n  }\n  .div-45 {\n    disply: flex;\n    flex-direction: column;\n    color: #fff;\n    text-align: center;\n    align-self: start;\n    position: relative;\n    white-space: nowrap;\n    fill: #198ddc;\n    overflow: hidden;\n    min-height: 72px;\n    margin-top: 77px;\n    width: 100%;\n    flex-grow: 1;\n    padding: 30px 72px 30px 99px;\n    font: 600 18px/100% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div-45 {\n      white-space: initial;\n      max-width: 100%;\n      margin-top: 40px;\n      padding: 0 20px 0 30px;\n    }\n  }\n  .img-19 {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n  .div-46 {\n    position: relative;\n  }\n  .column-3 {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 54%;\n    margin-left: 20px;\n  }\n  @media (max-width: 991px) {\n    .column-3 {\n      width: 100%;\n    }\n  }\n  .img-20 {\n    aspect-ratio: 1.17;\n    object-fit: contain;\n    object-position: center;\n    width: 100%;\n    overflow: hidden;\n    margin-top: 87px;\n    flex-grow: 1;\n  }\n  @media (max-width: 991px) {\n    .img-20 {\n      max-width: 100%;\n      margin-top: 40px;\n    }\n  }\n\n  .myLoanerContainer {\n    display: flex;\n    flex-direction: column;\n    width: 20px;\n    border-radius: 16.842px;\n    box-shadow:\n      0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n      background-color: var(--boxes, #F8F8FB);\n    align-self: center;\n    display: flex;\n    width: 350px;\n    height: 550px;\n    max-width: 100%;\n    text-align: center;\n    margin-right: 10px;\n    margin-top: -40px;\n  }\n  \n  .myLoanerContent {\n    display: flex;\n    margin-top: 10px;\n    flex-direction: column;\n    align-self: center;\n    width: 230px;\n    font-size: 24px;\n    justify-content: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"div": `Calculators_div__ktkng`,
	"div-2": `Calculators_div-2__RR8-s`,
	"div-3": `Calculators_div-3__Yp+C-`,
	"div-4": `Calculators_div-4__enjiX`,
	"img": `Calculators_img__qM2Cg`,
	"div-5": `Calculators_div-5__K6+Ou`,
	"div-6": `Calculators_div-6__s6WBv`,
	"div-7": `Calculators_div-7__1SZf0`,
	"div-8": `Calculators_div-8__zquMA`,
	"div-9": `Calculators_div-9__p8MrN`,
	"div-10": `Calculators_div-10__NQ8OT`,
	"img-2": `Calculators_img-2__qOi7H`,
	"div-11": `Calculators_div-11__XFxka`,
	"img-3": `Calculators_img-3__GXDte`,
	"img-4": `Calculators_img-4__rmvaW`,
	"div-12": `Calculators_div-12__a5CBT`,
	"div-13": `Calculators_div-13__2IN2F`,
	"column": `Calculators_column__Os1Fj`,
	"div-14": `Calculators_div-14__+xkSU`,
	"div-15": `Calculators_div-15__3Aawe`,
	"img-5": `Calculators_img-5__Hn0su`,
	"div-16": `Calculators_div-16__eviq0`,
	"div-17": `Calculators_div-17__LDzFs`,
	"img-6": `Calculators_img-6__rVKg8`,
	"div-18": `Calculators_div-18__FJvvJ`,
	"div-19": `Calculators_div-19__5v95D`,
	"img-7": `Calculators_img-7__PsMy0`,
	"div-20": `Calculators_div-20__CmDBU`,
	"div-21": `Calculators_div-21__WlePO`,
	"img-8": `Calculators_img-8__bQsUt`,
	"div-22": `Calculators_div-22__YQXGu`,
	"div-23": `Calculators_div-23__Ar2JW`,
	"img-9": `Calculators_img-9__T-xAw`,
	"div-24": `Calculators_div-24__bTpxD`,
	"div-25": `Calculators_div-25__fkaLJ`,
	"img-10": `Calculators_img-10__OIJ05`,
	"div-26": `Calculators_div-26__sQ-45`,
	"div-27": `Calculators_div-27__57icD`,
	"img-11": `Calculators_img-11__DVj4D`,
	"div-28": `Calculators_div-28__pW2Yw`,
	"div-29": `Calculators_div-29__4BVZK`,
	"img-12": `Calculators_img-12__VDU7F`,
	"div-30": `Calculators_div-30__YxT-w`,
	"div-31": `Calculators_div-31__xyTUt`,
	"div-32": `Calculators_div-32__WSy5d`,
	"div-33": `Calculators_div-33__ID-B6`,
	"img-13": `Calculators_img-13__1nONM`,
	"div-34": `Calculators_div-34__fdxrY`,
	"div-35": `Calculators_div-35__lPp7S`,
	"img-14": `Calculators_img-14__TGmku`,
	"div-36": `Calculators_div-36__0Xt7c`,
	"column-2": `Calculators_column-2__BOKyN`,
	"div-37": `Calculators_div-37__FOClc`,
	"div-38": `Calculators_div-38__FvG4I`,
	"div-39": `Calculators_div-39__JoKCS`,
	"img-15": `Calculators_img-15__sscmE`,
	"div-40": `Calculators_div-40__zJIK6`,
	"img-16": `Calculators_img-16__S-5J7`,
	"div-41": `Calculators_div-41__hvw7f`,
	"img-17": `Calculators_img-17__ORDfH`,
	"div-42": `Calculators_div-42__NAqcV`,
	"div-43": `Calculators_div-43__RTsMO`,
	"img-18": `Calculators_img-18__ZPne8`,
	"div-44": `Calculators_div-44__hHM-c`,
	"div-45": `Calculators_div-45__xpslx`,
	"img-19": `Calculators_img-19__NTwYf`,
	"div-46": `Calculators_div-46__NxiUV`,
	"column-3": `Calculators_column-3__N3F+5`,
	"img-20": `Calculators_img-20__Lkfde`,
	"myLoanerContainer": `Calculators_myLoanerContainer__TI6xE`,
	"myLoanerContent": `Calculators_myLoanerContent__86w30`
};
export default ___CSS_LOADER_EXPORT___;
